import React from 'react';
import { Button } from '../common';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { DialogTitleHighscores } from './components/DialogTitleCustom';
import { TableHighscores } from './TableHighscores';
import { RowData } from '../../types';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

export interface ServerData {
  place: number;
  address: string;
  nft: string;
  score: number;
  onChain: boolean;
  date: Date;
}

export type IDialogHighscores = {
  label: string;
  idLobby: number;
  onClick?: () => void;
  secondary?: boolean;
  className?: string;
  disabled?: boolean;
  success?: boolean;
  dataSize?: string;
  rowsData?: RowData[];
} & React.HTMLProps<HTMLButtonElement> &
  React.HTMLAttributes<HTMLButtonElement>;

export const DialogHighscores = (props: IDialogHighscores) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    if (props.onClick) props.onClick();
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button label={props.label} secondary={true} dataSize={'small'} onClick={handleClickOpen} />
      <Dialog onClose={handleClose} aria-labelledby={'id-lobby-' + props.idLobby} open={open} fullWidth maxWidth="md">
        <DialogTitleHighscores id={'id-lobby-' + props.idLobby} onClose={handleClose}>
          Highscores Lobby {props.idLobby}
        </DialogTitleHighscores>
        <DialogContent dividers className="main-color">
          <TableHighscores data={props.rowsData ?? []} idLobby={props.idLobby} />
        </DialogContent>
        <DialogActions className="main-color">
          <Button label={'Close'} autoFocus secondary={true} onClick={handleClose} />
        </DialogActions>
      </Dialog>
    </>
  );
};
